<template>
  <div>
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <title>colgante</title>
      <path fill="#679940" d="M23.44,6H17.06V3h3.5a1,1,0,0,0,0-2h-9a1,1,0,0,0,0,2h3.5V6H8.56a1,1,0,0,0-1,1V30a1,1,0,0,0,1,1H23.44a1,1,0,0,0,1-1V7A1,1,0,0,0,23.44,6Zm-1,23H9.56V8H22.44Z"></path>
      <path fill="#679940" d="M11.44,11V26a1,1,0,0,0,1,1h7a1,1,0,0,0,1-1V11a1,1,0,0,0-1-1h-7A1,1,0,0,0,11.44,11Zm2,1h5V25h-5Z"></path>
    </svg>
  </div>
</template>

<script>
export default {
  name: "ColganteIcon"
};
</script>


// WEBPACK FOOTER //
// src/icons/ColganteIcon.vue